import RoutesRoot from "./routes";

const App = () => {
  return (
    <RoutesRoot />
  );
};

export default App;
